<template>
  <div class="tr-adjustments">
    <div class="tr-adjust-title">
      <fa-icon class="tr-adjust-icon" :icon="['fal', 'clock']"/>
      Ajustes de glosa em repasses já pagos
    </div>
    <div class="tr-adjust-sub">
      Serão abatidos ou somados na próxima consolidação deste profissional
    </div>
    <div class="tr-adjust-row" v-for="item in items" :key="item.id">
      <span class="tr-pill" :class="item.kind === 'credit' ? 'tr-pill-credit' : 'tr-pill-debit'">
        {{ item.kind === 'credit' ? 'Crédito' : 'Débito' }}
      </span>
      <span class="tr-adjust-source">
        <b>{{ sourceLabel(item) }}</b>
        <template v-if="item.source && item.source.batchNumber">
          · Lote {{ item.source.batchNumber }}
        </template>
        <template v-if="item.source && item.source.guideNumber">
          · guia {{ item.source.guideNumber }}
        </template>
        <template v-if="item.source && item.source.itemName">
          · {{ item.source.itemName }}
        </template>
        <small v-if="item.source && item.source.insurance">
          — {{ item.source.insurance.customName }}
        </small>
      </span>
      <span class="tr-adjust-date">{{ item.createdAt | date }}</span>
      <span class="tr-adjust-value" :class="item.kind === 'credit' ? 'text-green' : 'text-error'">
        {{ signedCurrency(item.signedValue) }}
      </span>
      <button class="btn btn-sm btn-action btn-icon btn-gray tooltip tooltip-left"
              data-tooltip="Ver lote" :disabled="!item.source || !item.source.batchId"
              @click="$emit('open-batch', item.source.batchId)">
        <fa-icon :icon="['fal', 'eye']"/>
      </button>
    </div>
    <div class="tr-adjust-foot">
      <span class="text-gray">Saldo dos ajustes</span>
      <b :class="balance < 0 ? 'text-error' : 'text-green'">{{ signedCurrency(balance) }}</b>
    </div>
  </div>
</template>

<script>
import { signedCurrency } from '../helpers';

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    balance() {
      return this.items.reduce((sum, item) => sum + (Number(item.signedValue) || 0), 0);
    },
  },
  methods: {
    signedCurrency,
    sourceLabel(item) {
      const type = item.source ? item.source.type : null;
      if (type === 'recovery') return 'Recuperação';
      if (type === 'gloss') return 'Glosa';
      return 'Ajuste';
    },
  },
};
</script>
